'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Allow to add a null option to a select.
 * use as tl-null-option="my label text"
 */
ngModule.directive('tlNullOption', function () {
  return {
    priority: 600,
    // must execute before tlLovOptions
    require: "select",
    restrict: "A",
    link: {
      pre: function pre($scope, $el, $attrs, selectCtrl) {
        // adding option to select ctrl.
        var optionLabel = $attrs.tlNullOption;
        $("<option>").val("").text(optionLabel).appendTo($el);
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/tl/tlNullOption.js
// module id = 2906
// module chunks = 13